import { render, staticRenderFns } from "./ChatActionDialog.vue?vue&type=template&id=60f8b9ea&lang=pug&"
import script from "./ChatActionDialog.vue?vue&type=script&lang=js&"
export * from "./ChatActionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatActionDialog.vue"
export default component.exports